import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";

@Component({
    selector: "app-no-content",
    templateUrl: "./no-content.component.html",
    styleUrls: ["./no-content.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
/**
 *  This component manage no result data visualization in page.
 *  It accept an optional parameter in input called "text"
 *  If no text parameter is passed to component, the default text is "Nessun contenuto trovato"
 */
export class NoContentComponent implements OnInit, OnChanges, iTranslation {
  private _translateSubscription: Subscription = null;
  private _lblNoElementFound: string = "Nessun elemento trovato";

  public realtText: string = "x";

  @Input() text: string;

  /** Ionicons name for the illustration; defaults to the generic "cloud". */
  @Input() icon: string = "cloud";

  constructor(private _translateService: TranslateService) { }

  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();

    this.assignTranslation();
  }

  ngOnChanges(): void {

    this.assignTranslation();
  }

  ngOnDestroy() {
    this._translateSubscription.unsubscribe();
  }

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get(["dictionary.noContentMessage"])
      .subscribe((translation) => {
        this._lblNoElementFound = translation["dictionary.noContentMessage"];
      });

    this.assignTranslation();
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion

  private assignTranslation(): void {
    this.realtText = this.text ? this.text : this._lblNoElementFound;

  }
}
